/**
 * Pure cache invalidation logic for fulfilled actions.
 * Used by cacheInvalidationMiddleware; extracted so tests can run without loading slices.
 */
export function isFulfilledAction(action) {
    return typeof action.type === 'string' && action.type.endsWith('/fulfilled');
}
export function isRejectedAction(action) {
    return typeof action.type === 'string' && action.type.endsWith('/rejected');
}
/**
 * Async thunks that load/read data should not be treated as persistence save failures.
 * Matches action types containing common read prefixes: fetch, get_, load_, read_, refresh_
 */
export function isFetchDataRejectedAction(action) {
    if (typeof action.type !== 'string' || !action.type.endsWith('/rejected')) {
        return false;
    }
    // Match common read-only thunk naming patterns
    if (/\/(fetch|get_|load_|read_|refresh_)/i.test(action.type)) {
        return true;
    }
    // Sentinel "superseded" payloads are always from concurrent-fetch guards, not save errors
    if (typeof action.payload === 'string' &&
        action.payload.toUpperCase().includes('SUPERSEDED')) {
        return true;
    }
    return false;
}
/**
 * Runs cache invalidation for a fulfilled action: calls notifyStale for each
 * data type whose set includes action.type, and recordSaveSuccess once.
 */
export function handleFulfilledInvalidation(action, typeSets, notifyStale, recordSaveSuccess) {
    if (typeSets.auth.includes(action.type)) {
        notifyStale('auth');
        recordSaveSuccess(0);
    }
    if (typeSets.notes.includes(action.type)) {
        notifyStale('notes');
        recordSaveSuccess(0);
    }
    if (typeSets.lessons.includes(action.type)) {
        notifyStale('lessons');
        recordSaveSuccess(0);
    }
    if (typeSets.schedule.includes(action.type)) {
        notifyStale('schedule');
        recordSaveSuccess(0);
    }
    if (typeSets.payments.includes(action.type)) {
        notifyStale('payments');
        recordSaveSuccess(0);
    }
    if (typeSets.gamification.includes(action.type)) {
        notifyStale('gamification');
        recordSaveSuccess(0);
    }
}
